import services from "@/services/index.js";

export default {
    getRecentlySeen: async () => {
        return await services.getAsync({
            url: `/preferences/recents`,
            hasToken: true
        });
    },
    getSearchList: async () => {
        return await services.getAsync({
            url: `/preferences/searches`,
            hasToken: true
        });
    },

    postFakeDoorClick: async ({ resource, confirm = null }) => {
        return await services.postAsync({
            url: `/preferences/fake-doors`,
            body: { resource, confirm },
            timeout: 10000,
            hasToken: true
        });
    },
}